var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-menu-dots-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00034 2.66669C8.73673 2.66669 9.33369 2.06973 9.33369 1.33334C9.33369 0.596958 8.73673 0 8.00034 0C7.26395 0 6.66699 0.596958 6.66699 1.33334C6.66699 2.06973 7.26395 2.66669 8.00034 2.66669Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00034 9.33271C8.73673 9.33271 9.33369 8.73575 9.33369 7.99936C9.33369 7.26298 8.73673 6.66602 8.00034 6.66602C7.26395 6.66602 6.66699 7.26298 6.66699 7.99936C6.66699 8.73575 7.26395 9.33271 8.00034 9.33271Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00034 16.0007C8.73673 16.0007 9.33369 15.4037 9.33369 14.6673C9.33369 13.9309 8.73673 13.334 8.00034 13.334C7.26395 13.334 6.66699 13.9309 6.66699 14.6673C6.66699 15.4037 7.26395 16.0007 8.00034 16.0007Z",
    fill: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoDot);
export default __webpack_public_path__ + "static/media/iconInfoDot.af89ac86b770cf9efaeed6c52d202c7d.svg";
export { ForwardRef as ReactComponent };